import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "cancelButton"]

  disableAddButton() {
    this.addButtonTarget.disabled = true
  }

  disableCancelButton() {
    this.cancelButtonTarget.disabled = true
  }

  toggleLineThrough(e) {
    const toggleTarget = e.target.dataset.toggleLinethrough
    if (toggleTarget) {
      document.getElementById(toggleTarget)?.classList.toggle("line-through")
    }
  }
}
